/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ workspace: NonNullable<unknown> }} Connections_Slack_ConnectedInputs */



/**
* | output |
* | --- |
* | "Connected to {workspace}" |
*
* @param {Connections_Slack_ConnectedInputs} inputs
* @param {{ locale?: "en" | "nl" | "fr" }} options
* @returns {LocalizedString}
*/
export const connections_slack_connected = /** @type {((inputs: Connections_Slack_ConnectedInputs, options?: { locale?: "en" | "nl" | "fr" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Connections_Slack_ConnectedInputs, { locale?: "en" | "nl" | "fr" }, {}>} */ ((i, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "nl") return /** @type {LocalizedString} */ (`Gekoppeld aan ${i?.workspace}`)
	if (locale === "fr") return /** @type {LocalizedString} */ (`Connecté à ${i?.workspace}`)
	return /** @type {LocalizedString} */ (`Connected to ${i?.workspace}`)
});